import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import isUndefined from 'lodash/isUndefined';
import isObject from 'lodash/isObject';
var AdditionalErrorData = /*#__PURE__*/function () {
  function AdditionalErrorData(data) {
    _classCallCheck(this, AdditionalErrorData);
    this.data = isObject(data) ? data : {};
  }

  /**
   * @returns {string|null}
   */
  _createClass(AdditionalErrorData, [{
    key: "getErrorId",
    value: function getErrorId() {
      return isUndefined(this.data.errorId) ? null : this.data.errorId;
    }
  }]);
  return AdditionalErrorData;
}();
export default AdditionalErrorData;